// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__xp4Ug","assignButton":"CreateEditEquipmentSchedule_assignButton__h0ejS"};